/* @flow */

import React from 'react';
import glamorous from 'glamorous';
import { padding } from 'polished';
import Responsive from 'app/components/responsive/Responsive';
import Button from 'app/components/commons/Button';
import HowToPlayPane from './HowToPlayPane';

type Props = {
  onInnerRef: (number, Object) => void,
  pages: Array<Object>
};

const Content = glamorous.div({
  ...padding('1rem', null, '2rem'),
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center'
});

function HowToPlayContent({ onInnerRef, pages }: Props) {
  return (
    <Responsive desktop>
      {isDesktop => (
        <Content>
          {pages.map((page, i) => (
            <HowToPlayPane
              key={i} // eslint-disable-line react/no-array-index-key
              description={page.description}
              images={isDesktop ? page.desktopImages : page.mobileImages}
              video={page.videoUri}
              innerRef={ref => onInnerRef(i, ref)}
              frame={page.frame}
              title={page.title}
            />
          ))}
          <Button
            size="medium"
            kind="primary"
            link="/lobby"
            style={{ width: 130, textAlign: 'center' }}
          >
            PLAY NOW
          </Button>
        </Content>
      )}
    </Responsive>
  );
}

export default HowToPlayContent;
